import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const DASHBOARD_URL = `${TENANT_API_URL}/dashboard`;

export const getDashboardData = async () => {
  try {
    const response = await axiosInstance.get(`${DASHBOARD_URL}`);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
